import { REACT_APP_ARPS_BASE_URL } from "../utils/urls";

const searchAllCompanies = async (keyword: any, pagination: any) => {
  const { current, limit } = pagination;
  const skip = current * limit - limit;
  const result = await fetch(
    `${REACT_APP_ARPS_BASE_URL}/companies/search?keyword=${keyword}&skip=${skip}&limit=${limit}`
  );
  const companies = await result.json();
  return companies;
};

export default searchAllCompanies;
